import { gql } from '@/__generated__';

const GET_AUDIT_LOG_DETAILS = gql(`#graphql
  query GetAuditLogDetails($s3Object: String!) {
    auditLogDetails(s3Object: $s3Object)
  }
`);

export default GET_AUDIT_LOG_DETAILS;
